export enum PointPricePositionEnum {
  TECHNICIAN = "TECHNICIAN",
  DRIVER = "DRIVER",
  ASSISTANT = "ASSISTANT",
}
